/*
 * PLP Build Your Own Bundle (Option A: sticky bundle tray + Option C: live banner)
 *
 * Two parts, one file (loaded by both sections, runs once):
 *
 *   1. Tray     sections/collection-product-grid.liquid with "Build Your Own
 *               Bundle" on. Kit cards get "+ Add to bundle" / a − n + stepper;
 *               a sticky tray shows the kits, the 2 -> 3 -> 4+ progress, the
 *               add-ons and one "Add bundle to cart" button that adds every
 *               kit and add-on in ONE /cart/add.js request.
 *
 *   2. Banner   sections/buy-more-save-more-banner.liquid with "Live cart
 *               progress" on. Lights up the tiers reached and shows a live
 *               message for cart kits + kits in the tray.
 *
 * Pricing mirrors the multibuy-discount Function for tierMode "all_units":
 * the highest tier that (kits in the cart + kits in the tray) reaches sets
 * ONE % for every kit, rounded per unit, half-up to the cent. Add-ons get
 * addons.pct % off each unit once that count reaches addons.minKits. The PLP
 * only previews; checkout applies the discount from the product metafields.
 *
 * Cart lines carry the same hidden properties as the PDP box:
 *   kits     _mix_match:       "<group>"
 *   add-ons  _mix_match_addon: "<group>"
 *
 * Sidebar builder (section setting "Bundle layout: Sidebar builder")
 *   On desktop (1025px+) the same bundle is shown in a sticky rail beside the
 *   grid, always open: 2 / 3 / 4+ rows (they light up as kits are added;
 *   clicking one sets a target and shows empty "Pick a kit from the grid"
 *   slots, or trims the bundle back to that size), the kits with Remove and
 *   their options, the add-ons, the total and Add to cart (from 1 kit). The
 *   bottom tray is hidden there; below 1025px the tray works as before.
 *
 * Shared bundle (with the PDP Build Your Own box, mix-match-v3.js)
 *   The tray and the PDP box keep ONE bundle per group in localStorage
 *   ("sculpd:mm3:selection:<group>", 24 hours): kits picked on a product page
 *   show up in this tray and vice versa, and the header announcement bar
 *   counts cart + bundle on every page. Kits whose card isn't on this page
 *   are shown from the saved data (title, option, price, image). An older
 *   per-tab tray (sessionStorage "plpByob:<group>") is moved over once.
 *
 * Events
 *   listens   cart:updated, ajaxProduct:added, pageshow (bfcache),
 *             any /cart/add|change|update|clear request (UpCart),
 *             tab visible again,
 *             storage (the bundle changed in another tab),
 *             shopify:section:load / unload (theme editor)
 *   fires     plp-byob:update  { group, cart, bundle, total, pct }
 *             mm3:selection    { group, count } when the bundle is saved
 *             ajaxProduct:added after a successful add (opens the theme's /
 *             UpCart drawer, exactly like the PDP box does)
 *
 * window.PlpByob exposes the pure helpers for tests.
 */
(function (root) {
  'use strict';

  if (root.PlpByob && root.PlpByob.loaded) return;

  // ---------------------------------------------------------------------------
  // Pure helpers
  // ---------------------------------------------------------------------------

  /** Highest tier whose qty <= n (tiers ascending), or null. */
  function tierFor(tiers, n) {
    var found = null;
    for (var i = 0; i < tiers.length; i += 1) {
      if (tiers[i].qty <= n) found = tiers[i];
    }
    return found;
  }

  /** The next tier above n, or null. */
  function nextTier(tiers, n) {
    for (var i = 0; i < tiers.length; i += 1) {
      if (tiers[i].qty > n) return tiers[i];
    }
    return null;
  }

  function pctFor(tiers, n) {
    var t = tierFor(tiers, n);
    return t ? t.pct : 0;
  }

  /** One unit's price after pct: the Function's per-unit, half-up rounding. */
  function unitAfter(cents, pct) {
    var off = Math.min(Math.round((cents * pct) / 100), cents);
    return cents - off;
  }

  /**
   * Quote the tray.
   *   kits:     [cents, ...]   one entry per kit unit in the tray
   *   addons:   [cents, ...]   one entry per add-on unit picked
   *   cart:     kits already in the cart
   */
  function quote(config, kits, addons, cart) {
    var total = (cart || 0) + kits.length;
    var pct = pctFor(config.tiers, total);
    var was = 0;
    var pay = 0;
    kits.forEach(function (c) {
      was += c;
      pay += unitAfter(c, pct);
    });
    var addonOn = !!(config.addons && total >= config.addons.minKits);
    (addons || []).forEach(function (c) {
      was += c;
      pay += addonOn ? unitAfter(c, config.addons.pct) : c;
    });
    return { total: total, pct: pct, was: was, pay: pay, save: was - pay, addonOn: addonOn };
  }

  /**
   * Group kits in a /cart.js cart, with the Function's rule: a line counts
   * when its PRODUCT is in the group (custom.multibuy_config), which Liquid
   * decides and hands over as config.known {productId: true|false}. Bundles,
   * add-ons and other products never count, whatever properties they carry.
   *
   * A product Liquid hasn't seen (added after the page loaded, from outside
   * the group collection) is "unknown": it counts provisionally only if it
   * carries our _mix_match property, and the caller re-renders the section
   * (Section Rendering API) to get its real membership.
   *
   * Returns { count, lines: [{title, variant, quantity, image}], unknown: [ids] }
   */
  function cartMembers(cart, config) {
    var count = 0;
    var lines = [];
    var unknown = [];
    var known = config.known || {};
    ((cart && cart.items) || []).forEach(function (item) {
      var id = String(item.product_id);
      var props = item.properties || {};
      var member;
      if (Object.prototype.hasOwnProperty.call(known, id)) member = known[id] === true;
      else {
        if (unknown.indexOf(id) === -1) unknown.push(id);
        member = props._mix_match === config.group;
      }
      if (!member) return;
      var qty = parseInt(item.quantity, 10) || 0;
      count += qty;
      lines.push({
        productId: id,
        title: item.product_title || item.title || '',
        variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
        quantity: qty,
        image: item.image || (item.featured_image && item.featured_image.url) || '',
      });
    });
    return { count: count, lines: lines, unknown: unknown };
  }

  function countCart(cart, config) {
    return cartMembers(cart, config).count;
  }

  /**
   * Re-render one section to learn the membership of products the page
   * didn't know about. Each product id is asked about once per page.
   */
  function resolveUnknown(owner, sectionId, attr, unknown) {
    owner.asked = owner.asked || {};
    var ask = unknown.filter(function (id) {
      return !owner.asked[id];
    });
    if (!ask.length || !sectionId || !root.fetch) return null;
    ask.forEach(function (id) {
      owner.asked[id] = true;
    });
    var url = root.location.pathname + '?sections=' + encodeURIComponent(sectionId);
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        var html = json && json[sectionId];
        if (!html) return false;
        var re = new RegExp('<script type="application/json" ' + attr + '>([\\s\\S]*?)<\/script>');
        var m = html.match(re);
        if (!m) return false;
        var fresh = JSON.parse(m[1]);
        var known = owner.config.known || (owner.config.known = {});
        Object.keys(fresh.known || {}).forEach(function (id) {
          known[id] = fresh.known[id];
        });
        // Still unknown after a fresh render: not a kit for this group.
        ask.forEach(function (id) {
          if (!Object.prototype.hasOwnProperty.call(known, id)) known[id] = false;
        });
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return values[key] != null ? values[key] : match;
    });
  }

  function unit(n, strings) {
    return n === 1 ? strings.kitOne || 'kit' : strings.kitOther || 'kits';
  }

  /** The progress message for a total kit count (cart + tray). */
  function progressMessage(config, total, templates) {
    var strings = config.strings || {};
    var tiers = config.tiers;
    var cur = tierFor(tiers, total);
    var next = nextTier(tiers, total);
    var remaining = next ? next.qty - total : 0;
    var values = {
      count: total,
      count_unit: unit(total, strings),
      remaining: remaining,
      remaining_unit: unit(remaining, strings),
      pct: cur ? cur.pct : 0,
      next_pct: next ? next.pct : 0,
      addon_pct: config.addons ? config.addons.pct : '',
    };
    var key = !cur ? 'start' : next ? 'mid' : 'top';
    return { key: key, text: fill(templates[key], values), values: values };
  }

  function formatMoney(cents, format) {
    if (root.theme && root.theme.Currency && typeof root.theme.Currency.formatMoney === 'function') {
      try {
        return root.theme.Currency.formatMoney(cents, format);
      } catch (e) {
        /* fall through */
      }
    }
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function esc(text) {
    return String(text == null ? '' : text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function readJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  // ---------------------------------------------------------------------------
  // "Swap kit: options to show" (block setting on each kit's own PDP template)
  // ---------------------------------------------------------------------------
  // The option dropdowns in the tray / sidebar only offer the values the kit's
  // own template allows, like the PDP's Swap kit quick view. The setting lives
  // in the kit's template, so it is read from the kit's own page (its
  // data-mm3-config, streamed and cut off once found) and cached for 30 min in
  // localStorage ("sculpd:mm3:kitfilter:<handle>", also written by every kit
  // PDP for itself). A filter that would leave nothing is ignored.

  var FILTER_PREFIX = 'sculpd:mm3:kitfilter:';
  var FILTER_TTL = 30 * 60 * 1000;
  var CONFIG_RE = /<script type="application\/json" data-mm3-config>([\s\S]*?)<\/script>/g;
  var kitFilters = {};
  var kitFilterLoads = {};

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function cachedFilter(handle) {
    if (!handle) return null;
    if (kitFilters[handle]) return kitFilters[handle];
    try {
      var d = JSON.parse(root.localStorage.getItem(FILTER_PREFIX + handle) || 'null');
      if (d && Date.now() - d.at < FILTER_TTL && d.f && typeof d.f === 'object') {
        kitFilters[handle] = d.f;
        return d.f;
      }
    } catch (e) {
      /* no storage */
    }
    return null;
  }

  function storeFilter(handle, filter) {
    kitFilters[handle] = filter;
    try {
      root.localStorage.setItem(FILTER_PREFIX + handle, JSON.stringify({ at: Date.now(), f: filter }));
    } catch (e) {
      /* private mode */
    }
  }

  function findFilter(html, handle) {
    CONFIG_RE.lastIndex = 0;
    var m;
    while ((m = CONFIG_RE.exec(html))) {
      try {
        var cfg = JSON.parse(m[1]);
        if (cfg && cfg.product && String(cfg.product.handle) === String(handle)) return cfg.optionFilter || {};
      } catch (e) {
        /* not ours */
      }
    }
    return null;
  }

  function fetchFilter(url, handle) {
    return root.fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res || !res.ok) throw new Error('kit page ' + (res && res.status));
      if (!res.body || !root.TextDecoder) {
        return res.text().then(function (html) {
          return findFilter(html, handle) || {};
        });
      }
      var reader = res.body.getReader();
      var decoder = new root.TextDecoder();
      var html = '';
      function pump() {
        return reader.read().then(function (chunk) {
          if (chunk.done) return findFilter(html + decoder.decode(), handle) || {};
          html += decoder.decode(chunk.value, { stream: true });
          if (html.indexOf('data-mm3-config') !== -1) {
            var found = findFilter(html, handle);
            if (found) {
              reader.cancel().catch(function () {});
              return found;
            }
          }
          return pump();
        });
      }
      return pump();
    });
  }

  /** Resolves with the kit's filter ({} = none); never rejects. */
  function loadFilter(url) {
    var handle = handleFromUrl(url);
    if (!handle) return Promise.resolve({});
    var cached = cachedFilter(handle);
    if (cached) return Promise.resolve(cached);
    if (!kitFilterLoads[handle]) {
      kitFilterLoads[handle] = fetchFilter(url, handle)
        .then(function (filter) {
          storeFilter(handle, filter);
          return filter;
        })
        .catch(function () {
          delete kitFilterLoads[handle];
          return {};
        });
    }
    return kitFilterLoads[handle];
  }

  /** Variants whose option values the filter allows (all of them if none would be left). */
  function filterVariants(variants, names, filter) {
    if (!filter || !names || !names.length) return variants;
    var keys = Object.keys(filter).filter(function (k) {
      return Array.isArray(filter[k]) && filter[k].length;
    });
    if (!keys.length) return variants;
    var out = variants.filter(function (v) {
      if (!v.options) return true;
      return names.every(function (name, o) {
        var allowed = filter[name];
        return !allowed || !allowed.length || allowed.indexOf(v.options[o]) !== -1;
      });
    });
    return out.length ? out : variants;
  }

  var store = {
    get: function (key) {
      try {
        return JSON.parse(root.sessionStorage.getItem(key));
      } catch (e) {
        return null;
      }
    },
    set: function (key, value) {
      try {
        root.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (e) {
        /* private mode etc. */
      }
    },
  };

  // The bundle shared with the PDP box (mix-match-v3.js uses the same key,
  // fields and 24h lifetime; the announcement bar reads its length).
  var SHARED_PREFIX = 'sculpd:mm3:selection:';
  var SHARED_TTL = 24 * 60 * 60 * 1000;
  var shared = {
    get: function (group) {
      try {
        var data = JSON.parse(root.localStorage.getItem(SHARED_PREFIX + group) || 'null');
        if (!data || !(Date.now() - data.savedAt < SHARED_TTL)) return null;
        return data;
      } catch (e) {
        return null;
      }
    },
    set: function (group, slots, extras) {
      // Add-ons picked with no kit yet are kept too (they follow the customer
      // to every kit page, like the kits).
      var anyExtra = Object.keys(extras || {}).some(function (id) {
        return extras[id] && extras[id].on;
      });
      try {
        if (!slots.length && !anyExtra) root.localStorage.removeItem(SHARED_PREFIX + group);
        else {
          root.localStorage.setItem(
            SHARED_PREFIX + group,
            JSON.stringify({ v: 2, savedAt: Date.now(), qty: slots.length, slots: slots, extras: extras || {} })
          );
        }
      } catch (e) {
        /* private mode etc.: the tray still works on this page */
      }
      try {
        document.dispatchEvent(new CustomEvent('mm3:selection', { detail: { group: group, count: slots.length } }));
      } catch (e) {
        /* old browsers */
      }
    },
  };

  // ---------------------------------------------------------------------------
  // Shared cart state (one per page)
  // ---------------------------------------------------------------------------

  var cartState = { count: null, configs: [], pending: null };

  /*
   * Opens the cart slider after an add, like the theme's Add to cart: UpCart's
   * public API (refreshed first so it lists the new lines) when the store runs
   * UpCart; the theme's own drawer opens on ajaxProduct:added otherwise.
   */
  function openCartDrawer() {
    if (typeof root.SculpdOpenCart === 'function') return root.SculpdOpenCart();
    try {
      var open = function () {
        if (typeof root.upcartOpenCart === 'function') root.upcartOpenCart();
      };
      if (typeof root.upcartRefreshCart === 'function') {
        var done = root.upcartRefreshCart();
        if (done && typeof done.then === 'function') done.then(open, open);
        else root.setTimeout(open, 0);
      } else open();
    } catch (e) {
      /* the cart has the items anyway */
    }
  }

  /*
   * /cart.js. This theme's routes.cart is ALREADY "/cart.js" (routes.cartPage
   * is "/cart"); appending ".js" to it gave "/cart.js.js", a 404, so every
   * cart re-read failed silently and the tray / sidebar / banner only ever
   * knew the cart from page load (stale after any UpCart change).
   */
  function cartUrl() {
    var r = (root.theme && root.theme.routes) || {};
    var base = String(r.cartPage || r.cart || (root.Shopify && root.Shopify.routes && root.Shopify.routes.root ? root.Shopify.routes.root + 'cart' : '/cart'));
    base = base.split('?')[0].replace(/\/$/, '').replace(/\.js$/, '');
    return base + '.js';
  }

  function refreshCart() {
    // A read already in flight may have started BEFORE the cart changed:
    // read once more when it's done, so the last answer is always current.
    if (cartState.pending) {
      cartState.again = true;
      return cartState.pending;
    }
    cartState.again = false;
    cartState.pending = fetch(cartUrl(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cartState.pending = null;
        if (cartState.again) return refreshCart();
        applyCart(cart);
        return cart;
      })
      .catch(function () {
        cartState.pending = null;
        if (cartState.again) return refreshCart();
      });
    return cartState.pending;
  }

  var listeners = [];
  function applyCart(cart) {
    listeners.forEach(function (fn) {
      fn(cart);
    });
  }

  // ---------------------------------------------------------------------------
  // Tray
  // ---------------------------------------------------------------------------

  var trays = [];

  function Tray(section) {
    this.section = section;
    this.config = readJson(section.querySelector('script[data-plp-byob-config]'));
    if (!this.config || !this.config.valid || !this.config.tiers || !this.config.tiers.length) {
      this.config = null;
      return;
    }
    var c = this.config;
    c.tiers.sort(function (a, b) {
      return a.qty - b.qty;
    });
    c.strings = c.strings || {};
    c.topQty = c.topQty || c.tiers[c.tiers.length - 1].qty;
    c.maxKits = c.maxKits || 10;
    this.cartCount = c.cartCount || 0;
    this.items = []; // [{pid, vid}] one entry per kit unit
    this.extras = {}; // addonId -> {on, vid}
    this.open = false;
    this.busy = false;
    this.error = '';
    this.products = {};
    this.storeKey = 'plpByob:' + c.group;
    this.target = null; // sidebar: chosen bundle size (null = follow the kits)
    this.collectProducts();
    this.restore();
    this.build();
    this.buildRail();
    this.bind();
    this.render();
  }

  Tray.prototype.collectProducts = function () {
    var self = this;
    Array.prototype.forEach.call(this.section.querySelectorAll('[data-byob-card]'), function (card) {
      var data = readJson(card.querySelector('script[data-byob-product]'));
      if (!data || !data.variants || !data.variants.length) return;
      data.variantsById = {};
      data.variants.forEach(function (v) {
        data.variantsById[String(v.id)] = v;
      });
      self.products[String(data.id)] = data;
      // A card on the page is a kit by definition (Liquid decided).
      self.config.known[String(data.id)] = true;
    });
  };

  /**
   * A kit from the shared bundle whose card isn't on this page (picked on a
   * product page, or on another collection): a one-option product built from
   * the saved data, so the tray can show and add it.
   */
  Tray.prototype.productFromSlot = function (slot) {
    var pid = String(slot.productId);
    var existing = this.products[pid];
    var variant = { id: slot.variantId, title: slot.variantTitle || '', price: parseInt(slot.price, 10) || 0, image: slot.image || '' };
    if (existing) {
      if (!existing.variantsById[String(variant.id)]) {
        existing.variants.push(variant);
        existing.variantsById[String(variant.id)] = variant;
      }
      return existing;
    }
    var p = {
      id: slot.productId,
      title: slot.title || '',
      url: slot.url || '',
      image: slot.image || '',
      variantId: slot.variantId,
      variants: [variant],
      variantsById: {},
      offPage: true,
    };
    p.variantsById[String(variant.id)] = variant;
    this.products[pid] = p;
    return p;
  };

  Tray.prototype.restore = function () {
    var saved = shared.get(this.config.group);
    var legacy = null;
    if (!saved) {
      // Move an older per-tab tray over to the shared bundle, once.
      legacy = store.get(this.storeKey);
      try {
        root.sessionStorage.removeItem(this.storeKey);
      } catch (e) {
        /* nothing to remove */
      }
    }
    var self = this;
    if (saved) {
      (saved.slots || []).forEach(function (slot) {
        if (!slot || slot.productId == null || slot.variantId == null || self.items.length >= self.config.maxKits) return;
        var p = self.products[String(slot.productId)];
        if (!p || !p.variantsById[String(slot.variantId)]) p = self.productFromSlot(slot);
        self.items.push({ pid: String(slot.productId), vid: String(slot.variantId) });
      });
    } else if (legacy) {
      (legacy.items || []).forEach(function (it) {
        var p = self.products[String(it.pid)];
        if (p && p.variantsById[String(it.vid)] && self.items.length < self.config.maxKits) {
          self.items.push({ pid: String(it.pid), vid: String(it.vid) });
        }
      });
    }
    saved = saved || legacy;
    if (!saved) return;
    if (legacy) this.save();
    var addons = this.addonsById();
    Object.keys(saved.extras || {}).forEach(function (id) {
      var a = addons[id];
      var e = saved.extras[id];
      if (a && e && e.on && a.variantsById[String(e.vid)]) self.extras[id] = { on: true, vid: String(e.vid) };
    });
  };

  /** The tray as the shared bundle: one slot per kit, with what a PDP needs to show it. */
  Tray.prototype.save = function () {
    var self = this;
    var slots = this.items.map(function (it) {
      var p = self.products[it.pid] || {};
      var v = (p.variantsById && p.variantsById[it.vid]) || {};
      return {
        productId: parseInt(it.pid, 10),
        handle: p.handle || handleFromUrl(p.url),
        title: p.title || '',
        url: p.url || '',
        defaultOnly: !!(p.variants && p.variants.length === 1 && /^default title$/i.test(v.title || '')),
        variantId: parseInt(it.vid, 10),
        variantTitle: v.title || '',
        price: v.price || 0,
        image: v.image || p.image || '',
        available: true,
      };
    });
    var extras = {};
    Object.keys(this.extras).forEach(function (id) {
      if (self.extras[id] && self.extras[id].on) extras[id] = self.extras[id];
    });
    this.lastSaved = JSON.stringify(slots.map(function (x) { return [x.productId, x.variantId]; })) + JSON.stringify(extras);
    shared.set(this.config.group, slots, extras);
  };

  /** The shared bundle changed elsewhere (a PDP in another tab, or back/forward): reload it. */
  Tray.prototype.reload = function () {
    if (this.busy) return;
    var saved = shared.get(this.config.group);
    var sig = saved
      ? JSON.stringify((saved.slots || []).map(function (x) { return [x.productId, x.variantId]; })) + JSON.stringify(saved.extras || {})
      : '[]{}';
    if (sig === this.lastSaved) return;
    this.lastSaved = sig;
    this.items = [];
    this.extras = {};
    this.restore();
    if (!this.items.length && !this.pickedAddons().length) this.open = false;
    this.render();
  };

  Tray.prototype.addonsById = function () {
    if (this._addons) return this._addons;
    var map = {};
    var a = this.config.addons;
    if (a && a.items) {
      a.items.forEach(function (item) {
        item.variantsById = {};
        (item.variants || []).forEach(function (v) {
          item.variantsById[String(v.id)] = v;
        });
        if (!item.variants || !item.variants.length) return;
        map[String(item.id)] = item;
      });
    }
    this._addons = map;
    return map;
  };

  Tray.prototype.build = function () {
    var s = this.config.strings;
    var el = document.createElement('div');
    el.className = 'plp-byob';
    el.setAttribute('data-plp-byob-tray', this.config.group);
    el.setAttribute('style', this.section.getAttribute('data-byob-style') || '');
    el.hidden = true;
    el.innerHTML =
      '<div class="plp-byob__veil" data-byob-close hidden></div>' +
      '<div class="plp-byob__panel" data-byob-panel role="dialog" aria-modal="false" aria-label="' + esc(s.trayTitle) + '" hidden>' +
      '  <div class="plp-byob__panel-head"><p class="plp-byob__panel-title">' + esc(s.trayTitle) + '</p>' +
      '  <button type="button" class="plp-byob__close" data-byob-close aria-label="Close">&times;</button></div>' +
      '  <div class="plp-byob__panel-body">' +
      '    <div class="plp-byob__kits" data-byob-kits></div>' +
      '    <div class="plp-byob__addons" data-byob-addons></div>' +
      '  </div>' +
      '</div>' +
      '<div class="plp-byob__bar">' +
      '  <div class="plp-byob__inner">' +
      '    <div class="plp-byob__summary">' +
      '      <button type="button" class="plp-byob__title" data-byob-toggle aria-expanded="false">' +
      '        <span data-byob-title></span><span class="plp-byob__view">' + esc(s.viewLabel) + ' <span class="plp-byob__chev" aria-hidden="true"></span></span>' +
      '      </button>' +
      '      <div class="plp-byob__slots" data-byob-slots></div>' +
      '    </div>' +
      '    <div class="plp-byob__progress">' +
      '      <div class="plp-byob__steps" data-byob-steps></div>' +
      '      <p class="plp-byob__msg" data-byob-msg></p>' +
      '      <p class="plp-byob__cartnote" data-byob-cartnote hidden></p>' +
      '    </div>' +
      '    <div class="plp-byob__actions">' +
      '      <button type="button" class="plp-byob__extras" data-byob-extras hidden></button>' +
      '      <div class="plp-byob__total"><s data-byob-was></s><b data-byob-pay></b><small data-byob-save></small></div>' +
      '      <button type="button" class="plp-byob__cta" data-byob-cta></button>' +
      '    </div>' +
      '  </div>' +
      '  <p class="plp-byob__error" data-byob-error role="alert" hidden></p>' +
      '</div>';
    document.body.appendChild(el);
    this.el = el;
    this.q = function (sel) {
      return el.querySelector(sel);
    };
  };

  /** The sidebar builder's container (only with layout "sidebar" and its slot in the section). */
  Tray.prototype.buildRail = function () {
    this.rail = null;
    if (this.config.layout !== 'sidebar') return;
    var slot = this.section.querySelector('[data-byob-rail-slot]');
    if (!slot) return;
    var rail = document.createElement('div');
    rail.className = 'byob-rail';
    rail.setAttribute('data-plp-byob-rail', this.config.group);
    rail.setAttribute('style', this.section.getAttribute('data-byob-style') || '');
    slot.appendChild(rail);
    this.rail = rail;
    document.documentElement.classList.add('plp-byob-has-rail');
    // "Sidebar builder: also show the bottom tray on desktop".
    if (this.config.trayWithRail !== false) document.documentElement.classList.add('plp-byob-keep-tray');

    // Keep the whole rail inside the visible screen, so its pinned total and
    // Add to cart are always on screen: before it sticks (top of the page) it
    // starts lower down, so its height follows its position.
    var self = this;
    var frame = 0;
    var desktop = root.matchMedia ? root.matchMedia('(min-width: 1025px)') : null;
    this.fitRail = function () {
      frame = 0;
      if (!self.rail || (desktop && !desktop.matches)) {
        slot.style.maxHeight = '';
        return;
      }
      var top = Math.max(slot.getBoundingClientRect().top, 0);
      var h = Math.floor((root.innerHeight || 0) - top - 16);
      if (h > 200) slot.style.maxHeight = h + 'px';
    };
    this.onFit = function () {
      if (!frame) frame = (root.requestAnimationFrame || setTimeout)(self.fitRail);
    };
    root.addEventListener('scroll', this.onFit, { passive: true });
    root.addEventListener('resize', this.onFit);
    this.onFit();
  };

  /**
   * Sidebar: choose a bundle size. Smaller than the kits already in it trims
   * the newest kits (like the PDP box going from 3 to 2 kits); bigger shows
   * empty slots to fill from the grid.
   */
  Tray.prototype.setTarget = function (size) {
    size = parseInt(size, 10) || 0;
    if (size < 1) return;
    // Kits in the cart stay; the bundle is trimmed so cart + bundle fit the size.
    var room = Math.max(0, size - (this.cartCount || 0));
    if (this.items.length > room) this.items = this.items.slice(0, room);
    this.target = size;
    this.changed();
  };

  Tray.prototype.bind = function () {
    var self = this;

    this.onSectionClick = function (evt) {
      var t = evt.target.closest('[data-byob-add],[data-byob-inc],[data-byob-dec]');
      if (!t) return;
      var card = t.closest('[data-byob-card]');
      if (!card) return;
      evt.preventDefault();
      var pid = String(card.getAttribute('data-byob-pid'));
      if (t.hasAttribute('data-byob-dec')) self.removeOne(pid);
      // "Add to bundle" opens the quick view (setting); the stepper's + adds straight away.
      else if (t.hasAttribute('data-byob-add') && self.config.quickView !== false) self.openQuickView(pid, t);
      else self.addOne(pid);
    };
    this.section.addEventListener('click', this.onSectionClick);

    var onClick = function (evt) {
      var t = evt.target.closest('[data-byob-toggle],[data-byob-extras],[data-byob-close],[data-byob-remove],[data-byob-addon],[data-byob-cta],[data-byob-slot],[data-byob-size]');
      if (!t) return;
      if (t.hasAttribute('data-byob-size')) self.setTarget(t.getAttribute('data-byob-size'));
      else if (t.hasAttribute('data-byob-toggle') || t.hasAttribute('data-byob-slot')) self.setOpen(!self.open);
      else if (t.hasAttribute('data-byob-extras')) self.setOpen(true, 'addons');
      else if (t.hasAttribute('data-byob-close')) self.setOpen(false);
      else if (t.hasAttribute('data-byob-remove')) {
        self.items.splice(parseInt(t.getAttribute('data-byob-remove'), 10), 1);
        self.changed();
      } else if (t.hasAttribute('data-byob-addon')) {
        var id = t.getAttribute('data-byob-addon');
        var a = self.addonsById()[id];
        var cur = self.extras[id];
        if (cur && cur.on) cur.on = false;
        else {
          var aShown = self.shownVariants(a);
          var aVid = String((cur && cur.vid) || a.variantId || a.variants[0].id);
          if (!hasVariant(aShown, aVid)) aVid = String((aShown[0] || a.variants[0]).id);
          self.extras[id] = { on: true, vid: aVid };
        }
        self.changed();
      } else if (t.hasAttribute('data-byob-cta')) self.submit(t);
    };
    this.el.addEventListener('click', onClick);
    if (this.rail) this.rail.addEventListener('click', onClick);

    var onChange = function (evt) {
      var t = evt.target;
      if (t.hasAttribute('data-byob-variant')) {
        var i = parseInt(t.getAttribute('data-byob-variant'), 10);
        if (self.items[i]) self.items[i].vid = String(t.value);
        self.changed();
      } else if (t.hasAttribute('data-byob-addon-variant')) {
        var id = t.getAttribute('data-byob-addon-variant');
        var cur = self.extras[id] || { on: false };
        cur.vid = String(t.value);
        self.extras[id] = cur;
        self.changed();
      }
    };
    this.el.addEventListener('change', onChange);
    if (this.rail) this.rail.addEventListener('change', onChange);

    this.onKey = function (evt) {
      if (evt.key === 'Escape' && self.open) {
        self.setOpen(false);
        var toggle = self.q('[data-byob-toggle]');
        if (toggle) toggle.focus();
      }
    };
    document.addEventListener('keydown', this.onKey);

    this.onCart = function (cart) {
      self.lastCart = cart;
      var r = cartMembers(cart, self.config);
      self.cartCount = r.count;
      self.cartLines = r.lines;
      self.render();
      var pending = r.unknown.length && resolveUnknown(self, self.section.getAttribute('data-section-id'), 'data-plp-byob-config', r.unknown);
      if (pending) {
        pending.then(function (ok) {
          if (ok !== null) self.onCart(self.lastCart);
        });
      }
    };
    listeners.push(this.onCart);
  };

  Tray.prototype.destroy = function () {
    this.destroyed = true;
    this.section.removeEventListener('click', this.onSectionClick);
    document.removeEventListener('keydown', this.onKey);
    var i = listeners.indexOf(this.onCart);
    if (i > -1) listeners.splice(i, 1);
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
    if (this.onFit) {
      root.removeEventListener('scroll', this.onFit);
      root.removeEventListener('resize', this.onFit);
    }
    if (this.rail && this.rail.parentNode) this.rail.parentNode.removeChild(this.rail);
    document.documentElement.classList.remove('plp-byob-has-rail');
    document.documentElement.classList.remove('plp-byob-keep-tray');
    if (this.qvModal && this.qvModal.parentNode) this.qvModal.parentNode.removeChild(this.qvModal);
    document.body.classList.remove('plp-byob-qv-open');
    if (this.onQvKey) document.removeEventListener('keydown', this.onQvKey);
    document.documentElement.classList.remove('plp-byob-active');
    document.documentElement.style.removeProperty('--plp-byob-height');
  };

  /**
   * The variants a dropdown offers for a kit / add-on: its own template's
   * "Swap kit: options to show". Not loaded yet: all of them for now, and the
   * filter is fetched; when it arrives, kits on a value it hides move to the
   * first allowed one and the tray re-renders.
   */
  Tray.prototype.shownVariants = function (p) {
    if (!p || !p.variants || p.variants.length < 2 || !p.options || p.offPage) return (p && p.variants) || [];
    var handle = handleFromUrl(p.url);
    if (!handle) return p.variants;
    var filter = cachedFilter(handle);
    if (!filter) {
      var self = this;
      this.filterWait = this.filterWait || {};
      if (!this.filterWait[handle]) {
        this.filterWait[handle] = true;
        loadFilter(p.url).then(function () {
          self.applyFilters();
        });
      }
      return p.variants;
    }
    return filterVariants(p.variants, p.options, filter);
  };

  function hasVariant(list, vid) {
    for (var i = 0; i < list.length; i += 1) if (String(list[i].id) === String(vid)) return true;
    return false;
  }

  Tray.prototype.applyFilters = function () {
    if (this.destroyed) return;
    var self = this;
    var moved = false;
    this.items.forEach(function (it) {
      var list = self.shownVariants(self.products[it.pid]);
      if (list.length && !hasVariant(list, it.vid)) {
        it.vid = String(list[0].id);
        moved = true;
      }
    });
    var addons = this.addonsById();
    Object.keys(this.extras).forEach(function (id) {
      var e = self.extras[id];
      var list = self.shownVariants(addons[id]);
      if (e && e.vid && list.length && !hasVariant(list, e.vid)) {
        e.vid = String(list[0].id);
        moved = true;
      }
    });
    if (moved) this.save();
    this.render();
  };

  Tray.prototype.selectHtml = function (p, current, attr) {
    var list = this.shownVariants(p);
    if (list.length < 2) return '';
    var html = '<select class="plp-byob__select" ' + attr + ' aria-label="' + esc(p.title) + ': option">';
    list.forEach(function (o) {
      html += '<option value="' + o.id + '"' + (String(o.id) === String(current.id) ? ' selected' : '') + '>' + esc(o.title) + '</option>';
    });
    return html + '</select>';
  };

  // ---------------------------------------------------------------------------
  // "Add to bundle" quick view (section setting "Add to bundle opens the
  // product quick view"): the PDP Swap kit quick view, same section
  // (sections/mix-match-quickview.liquid via the Section Rendering API), same
  // styles (mix-match-v3.css), same rules: the kit's own "Swap kit: options to
  // show", sold-out values hidden at every option level ("Hide Sold Out
  // Variants" / "Allow Variant Exclusions"). "Add to bundle" adds the chosen
  // variant. If the quick view can't load, the card's kit is added as before.
  // ---------------------------------------------------------------------------

  var qvHtmlCache = {};

  function withParam(url, key, value) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + key + '=' + encodeURIComponent(value);
  }

  function loadQuickView(url, section) {
    var key = handleFromUrl(url) || url;
    if (!qvHtmlCache[key]) {
      qvHtmlCache[key] = root
        .fetch(withParam(url.split('?')[0], 'section_id', section), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
          return res.text();
        })
        .then(function (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var qv = holder.querySelector('[data-mm3-qv]');
          if (!qv) throw new Error('missing quick view');
          return qv.outerHTML;
        })
        .catch(function (err) {
          delete qvHtmlCache[key];
          throw err;
        });
    }
    return qvHtmlCache[key];
  }

  function qvFindVariant(list, selected) {
    for (var i = 0; i < list.length; i += 1) {
      var v = list[i];
      var ok = true;
      for (var o = 0; o < selected.length; o += 1) {
        if (v.options[o] !== selected[o]) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  // Same as mix-match-v3.js valueState: 'ok' | 'excluded' | 'soldout' | 'hidden'.
  function qvValueState(data, allowed, selected, index, value) {
    var matching = allowed.filter(function (v) {
      for (var k = 0; k < index; k += 1) if (v.options[k] !== selected[k]) return false;
      return v.options[index] === value;
    });
    if (!matching.length) return 'hidden';
    if (matching.some(function (v) { return v.available; })) return 'ok';
    if (data.hideSold === false) return 'soldout';
    if (data.allowExcluded !== false && matching.some(function (v) { return v.exclude; })) return 'excluded';
    return 'hidden';
  }

  Tray.prototype.buildQuickView = function () {
    if (this.qvModal || this.config.quickView === false) return;
    var s = this.config.strings;
    var modal = document.createElement('div');
    modal.className = 'mm3-modal plp-byob-qv';
    modal.hidden = true;
    modal.setAttribute('style', this.section.getAttribute('data-byob-style') || '');
    modal.innerHTML =
      '<div class="mm3-modal__backdrop" data-byob-qv-close></div>' +
      '<div class="mm3-modal__dialog" role="dialog" aria-modal="true" aria-label="' + esc(s.qvAdd ? 'Product quick view' : '') + '" tabindex="-1" data-byob-qv-dialog>' +
      '<section class="mm3-modal__view" data-mm3-view="qv">' +
      '<header class="mm3-modal__bar mm3-modal__bar--qv">' +
      '<p class="mm3-modal__step" data-byob-qv-step></p>' +
      '<button type="button" class="mm3-modal__close" data-byob-qv-close aria-label="Close">&times;</button>' +
      '</header>' +
      '<div class="mm3-modal__body mm3-modal__body--qv" data-byob-qv-body aria-live="polite"></div>' +
      '<footer class="mm3-modal__footer">' +
      '<button type="button" class="btn btn--full mm3-modal__use" data-byob-qv-use disabled></button>' +
      '<a class="mm3-modal__full" data-byob-qv-full href="#" target="_blank" rel="noopener">' + esc(s.qvFull || 'View full product page (opens in a new tab)') + '</a>' +
      '</footer>' +
      '</section></div>';
    document.body.appendChild(modal);
    this.qvModal = modal;
    this.qvBody = modal.querySelector('[data-byob-qv-body]');
    this.qvView = modal.querySelector('[data-mm3-view="qv"]');
    this.qvFooter = modal.querySelector('.mm3-modal__footer');
    this.qvUse = modal.querySelector('[data-byob-qv-use]');
    this.qvFull = modal.querySelector('[data-byob-qv-full]');
    this.qvDesktop = root.matchMedia ? root.matchMedia('(min-width: 750px)') : null;

    var self = this;
    // A photo finishing loading changes the painted area (iOS blank areas).
    if (this.qvBody) {
      this.qvBody.addEventListener(
        'load',
        function (evt) {
          if (evt.target && evt.target.tagName === 'IMG') refreshPaint(self.qvBody);
        },
        true
      );
    }
    modal.addEventListener('click', function (evt) {
      var t = evt.target;
      if (t.closest('[data-byob-qv-close]')) {
        self.closeQuickView();
        return;
      }
      if (t.closest('[data-byob-qv-use]')) {
        self.useQuickView();
        return;
      }
      var thumb = t.closest('[data-mm3-qv-thumb]');
      if (thumb) {
        var main = self.qvBody.querySelector('.mm3-qv__main-img');
        if (main) {
          main.setAttribute('src', thumb.getAttribute('data-mm3-qv-thumb'));
          main.removeAttribute('srcset');
        }
        Array.prototype.forEach.call(self.qvBody.querySelectorAll('.mm3-qv__thumb'), function (b) {
          b.classList.toggle('is-active', b === thumb);
        });
        refreshPaint(self.qvBody);
        return;
      }
      var slide = t.closest('[data-mm3-slide]');
      if (slide) {
        var track = slide.closest('[data-mm3-slider]').querySelector('[data-mm3-track]');
        var step = Math.max(track.clientWidth * 0.75, 70) * parseInt(slide.getAttribute('data-mm3-slide'), 10);
        if (track.scrollBy) track.scrollBy({ left: step, behavior: 'smooth' });
        else track.scrollLeft += step;
      }
    });
    modal.addEventListener('change', function (evt) {
      var input = evt.target.closest('[data-mm3-input]');
      if (!input || !self.qv) return;
      self.qv.selected[parseInt(input.getAttribute('data-mm3-input'), 10)] = input.value;
      self.renderQuickView();
    });
    this.onQvKey = function (evt) {
      if (evt.key === 'Escape' && self.qvModal && !self.qvModal.hidden) self.closeQuickView();
    };
    document.addEventListener('keydown', this.onQvKey);
    this.onQvMedia = function () {
      self.placeQvFooter();
    };
    if (this.qvDesktop) {
      if (this.qvDesktop.addEventListener) this.qvDesktop.addEventListener('change', this.onQvMedia);
      else if (this.qvDesktop.addListener) this.qvDesktop.addListener(this.onQvMedia);
    }
  };

  // Desktop: the button sits in the info column (as on the PDP); mobile: a sticky footer.
  Tray.prototype.placeQvFooter = function () {
    if (!this.qvFooter) return;
    var info = this.qvBody.querySelector('.mm3-qv__info');
    var target = this.qvDesktop && this.qvDesktop.matches && info ? info : this.qvView;
    if (this.qvFooter.parentNode !== target) target.appendChild(this.qvFooter);
  };

  // See mix-match-v3.js refreshPaint (iOS blank areas after a content change).
  function refreshPaint(box) {
    if (typeof root.SculpdRefreshPaint === 'function') return root.SculpdRefreshPaint(box);
    var content = box && box.firstElementChild;
    if (!content) return;
    var raf = root.requestAnimationFrame || function (fn) {
      return setTimeout(fn, 16);
    };
    content.style.opacity = '0.999';
    void content.offsetHeight;
    raf(function () {
      raf(function () {
        content.style.opacity = '';
      });
    });
  }

  Tray.prototype.setQvBody = function (html) {
    if (this.qvFooter.parentNode !== this.qvView) this.qvView.appendChild(this.qvFooter);
    this.qvBody.innerHTML = html;
    this.placeQvFooter();
    // iOS Safari repaint (see mix-match-v3.js repaintBody): reflow + scroll nudge.
    // Only while the customer hasn't scrolled (a write mid-scroll stops it).
    var box = this.qvBody;
    var touched = false;
    var mark = function () {
      touched = true;
    };
    box.addEventListener('touchstart', mark, { once: true, passive: true });
    box.addEventListener('wheel', mark, { once: true, passive: true });
    var nudge = function () {
      if (touched || box.scrollTop !== 0) return;
      void box.offsetHeight;
      box.scrollTop = 1;
      box.scrollTop = 0;
    };
    nudge();
    setTimeout(nudge, 60);
    setTimeout(nudge, 400);
  };

  Tray.prototype.openQuickView = function (pid, trigger) {
    var p = this.products[pid];
    if (!p || !p.url || this.config.quickView === false) {
      this.addOne(pid);
      return;
    }
    this.buildQuickView();
    var self = this;
    var s = this.config.strings;
    var token = {};
    this.qvToken = token;
    this.qv = null;
    this.qvPid = pid;
    this.qvTrigger = trigger || null;
    this.qvUse.disabled = true;
    this.qvUse.textContent = fill(s.qvAdd || 'Add to bundle · [price]', { price: '' }).replace(/\s·\s*$/, '');
    this.qvFull.setAttribute('href', p.url);
    this.qvModal.querySelector('[data-byob-qv-step]').textContent = fill(s.qvStep || 'Kit [n] in your bundle', { n: this.items.length + 1 });
    this.setQvBody('<p class="mm3-qv__loading">' + esc(s.qvLoading || 'Loading…') + '</p>');
    this.qvModal.hidden = false;
    document.body.classList.add('plp-byob-qv-open');
    var dialog = this.qvModal.querySelector('[data-byob-qv-dialog]');
    if (dialog && dialog.focus) dialog.focus({ preventScroll: true });

    Promise.all([loadQuickView(p.url, this.config.quickViewSection || 'mix-match-quickview'), loadFilter(p.url)]).then(
      function (results) {
        if (self.qvToken !== token || self.qvModal.hidden) return;
        self.setQvBody(results[0]);
        var data;
        try {
          data = JSON.parse(self.qvBody.querySelector('[data-mm3-qv-data]').textContent);
        } catch (e) {
          self.closeQuickView(true);
          self.addOne(pid);
          return;
        }
        var allowed = filterVariants(data.variants, data.options, results[1] || {});
        // Start on the variant this kit last had in the bundle, else the card's.
        var want = String(p.variantId);
        for (var i = self.items.length - 1; i >= 0; i -= 1) {
          if (self.items[i].pid === pid) {
            want = String(self.items[i].vid);
            break;
          }
        }
        var start = null;
        allowed.forEach(function (v) {
          if (!start && String(v.id) === want && v.available) start = v;
        });
        allowed.forEach(function (v) {
          if (!start && v.available) start = v;
        });
        start = start || allowed[0];
        self.qv = { data: data, allowed: allowed, selected: start.options.slice(), variant: start };
        self.renderQuickView();
      },
      function () {
        // Quick view unavailable: add the card's kit, as without the setting.
        if (self.qvToken !== token) return;
        self.closeQuickView(true);
        self.addOne(pid);
      }
    );
  };

  Tray.prototype.renderQuickView = function () {
    var qv = this.qv;
    if (!qv) return;
    var data = qv.data;
    var allowed = qv.allowed;
    var body = this.qvBody;
    var s = this.config.strings;

    // A chosen value that is hidden now moves to the first one that can be bought.
    for (var o = 0; o < qv.selected.length; o += 1) {
      if (qvValueState(data, allowed, qv.selected, o, qv.selected[o]) !== 'hidden') continue;
      var values = Array.prototype.map.call(body.querySelectorAll('[data-mm3-option="' + o + '"] [data-mm3-value-wrap]'), function (w) {
        return w.getAttribute('data-mm3-value');
      });
      var pick = null;
      ['ok', 'excluded', 'soldout'].some(function (wanted) {
        values.some(function (value) {
          if (qvValueState(data, allowed, qv.selected, o, value) === wanted) pick = value;
          return pick !== null;
        });
        return pick !== null;
      });
      if (pick !== null) qv.selected[o] = pick;
    }
    Array.prototype.forEach.call(body.querySelectorAll('[data-mm3-input]'), function (input) {
      input.checked = input.value === qv.selected[parseInt(input.getAttribute('data-mm3-input'), 10)];
    });

    Array.prototype.forEach.call(body.querySelectorAll('[data-mm3-option]'), function (wrap) {
      var index = parseInt(wrap.getAttribute('data-mm3-option'), 10);
      var label = wrap.querySelector('[data-mm3-option-selected]');
      if (label) label.textContent = qv.selected[index];
      Array.prototype.forEach.call(wrap.querySelectorAll('[data-mm3-value-wrap]'), function (valueWrap) {
        var status = qvValueState(data, allowed, qv.selected, index, valueWrap.getAttribute('data-mm3-value'));
        valueWrap.hidden = status === 'hidden';
        var off = status === 'excluded' || status === 'soldout';
        valueWrap.classList.toggle('disabled', off);
        valueWrap.classList.toggle('is-excluded', status === 'excluded');
        var l = valueWrap.querySelector('label');
        if (l) l.classList.toggle('disabled', off);
      });
    });

    var variant = qvFindVariant(allowed, qv.selected);
    qv.variant = variant;
    var buyable = !!variant && variant.available;
    var soldOut = body.querySelector('[data-mm3-qv-soldout]');
    if (soldOut) soldOut.hidden = buyable;

    // Price in the bundle: this kit as one more kit (cart + bundle + 1).
    var nowEl = body.querySelector('[data-mm3-qv-now]');
    var wasEl = body.querySelector('[data-mm3-qv-was]');
    var pillEl = body.querySelector('[data-mm3-qv-pill]');
    var deltaEl = body.querySelector('[data-mm3-qv-delta]');
    if (deltaEl) deltaEl.textContent = '';
    if (!variant) {
      this.qvUse.disabled = true;
      return;
    }
    var pct = pctFor(this.config.tiers, (this.cartCount || 0) + this.items.length + 1);
    var now = unitAfter(variant.price, pct);
    if (nowEl) nowEl.textContent = this.money(now);
    if (wasEl) wasEl.textContent = now < variant.price ? this.money(variant.price) : '';
    if (pillEl) {
      pillEl.textContent = pct ? fill(s.qvPill || '[pct]% off in your bundle', { pct: pct }) : '';
      pillEl.hidden = !pct;
    }
    var main = body.querySelector('.mm3-qv__main-img');
    if (main && variant.imageLarge && qv.imageVariant !== variant.id) {
      qv.imageVariant = variant.id;
      main.setAttribute('src', variant.imageLarge);
      main.removeAttribute('srcset');
    }
    this.qvUse.disabled = !buyable;
    this.qvUse.textContent = buyable ? fill(s.qvAdd || 'Add to bundle · [price]', { price: this.money(now) }) : s.qvSoldOut || 'Sold out';
    this.qvFull.setAttribute('href', withParam(String(data.url || this.products[this.qvPid].url).split('?')[0], 'variant', variant.id));
    refreshPaint(body);
  };

  Tray.prototype.useQuickView = function () {
    var qv = this.qv;
    if (!qv || !qv.variant || !qv.variant.available) return;
    var pid = this.qvPid;
    var p = this.products[pid];
    var v = qv.variant;
    var vid = String(v.id);
    if (p && !p.variantsById[vid]) {
      var img = v.image || p.image;
      var added = { id: v.id, title: v.title, price: v.price, options: v.options, image: img };
      p.variants.push(added);
      p.variantsById[vid] = added;
    }
    if (this.items.length >= this.config.maxKits) {
      this.closeQuickView();
      this.error = fill(this.config.strings.maxError, { max: this.config.maxKits });
      this.render();
      return;
    }
    this.items.push({ pid: pid, vid: vid });
    this.closeQuickView();
    this.changed();
  };

  Tray.prototype.closeQuickView = function (silent) {
    if (!this.qvModal || this.qvModal.hidden) return;
    this.qvModal.hidden = true;
    this.qv = null;
    this.qvToken = null;
    document.body.classList.remove('plp-byob-qv-open');
    var trigger = this.qvTrigger;
    this.qvTrigger = null;
    if (!silent && trigger && document.documentElement.contains(trigger) && trigger.focus) trigger.focus({ preventScroll: true });
  };

  Tray.prototype.addOne = function (pid) {
    var p = this.products[pid];
    if (!p) return;
    if (this.items.length >= this.config.maxKits) {
      this.error = fill(this.config.strings.maxError, { max: this.config.maxKits });
      this.render();
      return;
    }
    // Same variant as the last one of this kit, else the card's variant.
    var vid = String(p.variantId);
    for (var i = this.items.length - 1; i >= 0; i -= 1) {
      if (this.items[i].pid === pid) {
        vid = this.items[i].vid;
        break;
      }
    }
    var shown = this.shownVariants(p);
    if (!p.variantsById[vid] || !hasVariant(shown, vid)) vid = String((shown[0] || p.variants[0]).id);
    this.items.push({ pid: pid, vid: vid });
    this.changed();
  };

  Tray.prototype.removeOne = function (pid) {
    for (var i = this.items.length - 1; i >= 0; i -= 1) {
      if (this.items[i].pid === pid) {
        this.items.splice(i, 1);
        break;
      }
    }
    this.changed();
  };

  Tray.prototype.changed = function () {
    this.error = '';
    if (!this.items.length) this.setOpen(false, null, true);
    this.save();
    this.render();
  };

  Tray.prototype.setOpen = function (open, focus, silent) {
    // With no kits yet the panel still opens for the add-ons (they can be
    // picked first and are kept in the shared bundle, like kits).
    this.open = !!open && (this.items.length > 0 || Object.keys(this.addonsById()).length > 0);
    if (!silent) this.render();
    if (this.open && focus === 'addons') {
      var addons = this.q('[data-byob-addons]');
      if (addons && addons.scrollIntoView) addons.scrollIntoView({ block: 'nearest' });
    }
  };

  Tray.prototype.unitPrice = function (it) {
    var p = this.products[it.pid];
    var v = p && p.variantsById[it.vid];
    return v ? v.price : 0;
  };

  Tray.prototype.pickedAddons = function () {
    var self = this;
    var addons = this.addonsById();
    var list = [];
    Object.keys(this.extras).forEach(function (id) {
      var e = self.extras[id];
      var a = addons[id];
      if (!e || !e.on || !a) return;
      var v = a.variantsById[e.vid] || a.variants[0];
      list.push({ id: id, addon: a, variant: v });
    });
    return list;
  };

  Tray.prototype.money = function (cents) {
    return formatMoney(cents, this.config.moneyFormat);
  };

  Tray.prototype.render = function () {
    var c = this.config;
    var s = c.strings;
    var self = this;
    var kits = this.items.map(function (it) {
      return self.unitPrice(it);
    });
    var picked = this.pickedAddons();
    var q = quote(c, kits, picked.map(function (x) {
      return x.variant.price;
    }), this.cartCount);
    var bundle = this.items.length;

    // ---- Cards ----
    var countByPid = {};
    this.items.forEach(function (it) {
      countByPid[it.pid] = (countByPid[it.pid] || 0) + 1;
    });
    var minQty = c.tiers[0].qty;
    Array.prototype.forEach.call(this.section.querySelectorAll('[data-byob-card]'), function (card) {
      var pid = String(card.getAttribute('data-byob-pid'));
      var p = self.products[pid];
      if (!p) return;
      var inBundle = countByPid[pid] || 0;
      // Sidebar: with a size chosen (e.g. 3 kits), price the cards at that size.
      var reach = Math.max(q.total + (inBundle ? 0 : 1), minQty, self.rail && self.target ? self.target : 0);
      var pct = pctFor(c.tiers, reach);
      var vid = String(p.variantId);
      if (inBundle) {
        for (var i = self.items.length - 1; i >= 0; i -= 1) {
          if (self.items[i].pid === pid) {
            vid = self.items[i].vid;
            break;
          }
        }
      }
      var v = p.variantsById[vid] || p.variants[0];
      var top = reach >= c.topQty;
      var line = card.querySelector('[data-byob-price-line]');
      if (line) {
        line.textContent = fill(top ? s.priceLineTop : s.priceLine, {
          price: self.money(unitAfter(v.price, pct)),
          count: top ? c.topQty : reach,
        });
      }
      var add = card.querySelector('[data-byob-add]');
      var stepper = card.querySelector('[data-byob-stepper]');
      if (add) add.hidden = inBundle > 0;
      if (stepper) {
        stepper.hidden = inBundle === 0;
        var label = stepper.querySelector('[data-byob-qty-label]');
        if (label) label.textContent = fill(s.inBundleLabel, { count: inBundle });
        var inc = stepper.querySelector('[data-byob-inc]');
        if (inc) inc.disabled = bundle >= c.maxKits;
      }
      card.classList.toggle('is-in-bundle', inBundle > 0);
    });

    // ---- Tray visibility ----
    // Always shown while "Build Your Own Bundle" is on for this section, also
    // with no kits picked (0 kits, "Add 2 kits..." message, button disabled).
    // It used to show only with kits in the bundle, so after adding the
    // bundle to cart, or removing kits in UpCart and coming back to the PLP,
    // the bar disappeared on mobile. (Desktop with the sidebar builder still
    // follows "also show the bottom tray", in plp-byob.css.)
    var visible = true;
    this.el.hidden = !visible;
    this.el.classList.toggle('is-open', this.open);
    document.documentElement.classList.toggle('plp-byob-active', visible);

    // ---- Summary + slots ----
    // Kits already in the cart count toward the tier (the discount is cart
    // wide), so say so in the heading: "Your bundle · 2 kits + 3 in cart".
    this.q('[data-byob-title]').textContent = fill(this.cartCount ? s.trayHeadingCart || s.trayHeading : s.trayHeading, {
      title: s.trayTitle,
      count: bundle,
      count_unit: unit(bundle, s),
      cart: this.cartCount,
      cart_unit: unit(this.cartCount, s),
      total: q.total,
    });
    var toggle = this.q('[data-byob-toggle]');
    toggle.setAttribute('aria-expanded', this.open ? 'true' : 'false');

    // Kits already in the cart fill the first slots (they count toward the
    // tier), then this bundle's kits, then empty "+" slots up to the top tier.
    var entries = [];
    var self = this;
    if (this.cartCount) {
      (this.cartLines || []).forEach(function (line) {
        // The cart's own line image; the grid's product image as a fallback.
        var known = self.products[String(line.productId)];
        var img = line.image || (known && known.image) || '';
        for (var k = 0; k < line.quantity; k += 1) entries.push({ cart: true, title: line.title || '', img: img });
      });
    }
    this.items.forEach(function (it) {
      var p = self.products[it.pid];
      var v = p.variantsById[it.vid] || p.variants[0];
      entries.push({ cart: false, title: p.title || '', img: v.image || p.image });
    });
    var slotCount = Math.max(c.topQty, entries.length);
    var maxShown = 6;
    var slotsHtml = '';
    for (var i = 0; i < Math.min(slotCount, maxShown); i += 1) {
      var e = entries[i];
      if (e && !(i === maxShown - 1 && entries.length > maxShown)) {
        var label = e.cart ? e.title + ' (' + (s.railInCart || 'In your cart') + ')' : e.title;
        slotsHtml +=
          '<button type="button" class="plp-byob__slot is-filled' + (e.cart ? ' is-cart' : '') + '" data-byob-slot aria-label="' + esc(label) + '">' +
          (e.img ? '<img src="' + esc(e.img) + '" alt="" width="46" height="46" loading="lazy">' : '<span>' + esc(e.title.charAt(0)) + '</span>') +
          (e.cart ? '<span class="plp-byob__slot-cart" aria-hidden="true"></span>' : '') +
          '</button>';
      } else if (e) {
        slotsHtml += '<button type="button" class="plp-byob__slot is-more" data-byob-slot>+' + (entries.length - maxShown + 1) + '</button>';
      } else {
        slotsHtml += '<span class="plp-byob__slot" aria-hidden="true">+</span>';
      }
    }
    this.q('[data-byob-slots]').innerHTML = slotsHtml;

    // ---- Progress steps ----
    var stepsHtml = '';
    for (var n = 1; n <= c.topQty; n += 1) {
      var t = null;
      c.tiers.forEach(function (tier) {
        if (tier.qty === n) t = tier;
      });
      var reached = q.total >= n;
      // Every reached step is the same colour: kits already in the cart count
      // toward the tier just like the bundle's (the slots show which is which).
      var label = t ? fill(n === c.topQty ? s.stepTopLabel : s.stepLabel, { qty: n, pct: t.pct }) : n === 1 ? s.stepOneLabel : '';
      stepsHtml +=
        '<div class="plp-byob__step' + (reached ? ' is-reached' : '') + (t ? ' is-tier' : '') + '">' +
        '<span class="plp-byob__step-bar"></span>' +
        '<span class="plp-byob__step-label">' + esc(label) + '</span></div>';
    }
    this.q('[data-byob-steps]').innerHTML = stepsHtml;
    var msg = progressMessage(c, q.total, s.trayMsgs);
    this.q('[data-byob-msg]').innerHTML = esc(msg.text).replace(/\*([^*]+)\*/g, '<em>$1</em>');
    var note = this.q('[data-byob-cartnote]');
    note.hidden = !this.cartCount;
    note.innerHTML = this.cartCount
      ? esc(fill(s.cartNote, { count: this.cartCount, count_unit: unit(this.cartCount, s), total: q.total }))
      : '';

    // ---- Totals + buttons ----
    this.q('[data-byob-was]').textContent = q.save > 0 ? this.money(q.was) : '';
    this.q('[data-byob-pay]').textContent = this.money(q.pay);
    this.q('[data-byob-save]').textContent = q.save > 0 ? fill(s.saveLabel, { amount: this.money(q.save) }) : '';
    var extrasBtn = this.q('[data-byob-extras]');
    var addonCount = Object.keys(this.addonsById()).length;
    extrasBtn.hidden = !addonCount;
    if (addonCount) {
      extrasBtn.textContent = fill(s.extrasLabel, {
        count: picked.length ? ' (' + picked.length + ')' : '',
        pct: c.addons.pct,
      });
    }
    var cta = this.q('[data-byob-cta]');
    cta.disabled = this.busy || !bundle;
    cta.classList.toggle('is-loading', this.busy);
    cta.textContent = this.busy ? s.addingLabel : fill(s.ctaLabel, { total: this.money(q.pay), count: bundle, count_unit: unit(bundle, s) });

    var err = this.q('[data-byob-error]');
    err.hidden = !this.error;
    err.textContent = this.error;

    // ---- Panel ----
    var panel = this.q('[data-byob-panel]');
    panel.hidden = !this.open;
    this.q('[data-byob-close].plp-byob__veil').hidden = !this.open;
    if (this.open) this.renderPanel(q, picked);

    // Room for the tray at the bottom of the page.
    var bar = this.q('.plp-byob__bar');
    if (visible && bar) document.documentElement.style.setProperty('--plp-byob-height', bar.offsetHeight + 'px');

    if (this.rail) this.renderRail(q, picked);
    this.broadcast(q);
  };

  Tray.prototype.renderPanel = function (q, picked) {
    var c = this.config;
    var s = c.strings;
    var self = this;
    var html = '<p class="plp-byob__sub">' + esc(fill(s.panelKits, { count: this.items.length, count_unit: unit(this.items.length, s), pct: q.pct })) + '</p><ul class="plp-byob__list">';
    this.items.forEach(function (it, i) {
      var p = self.products[it.pid];
      var v = p.variantsById[it.vid] || p.variants[0];
      var img = v.image || p.image;
      var after = unitAfter(v.price, q.pct);
      var select = self.selectHtml(p, v, 'data-byob-variant="' + i + '"');
      html +=
        '<li class="plp-byob__row">' +
        '<span class="plp-byob__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</span>' +
        '<span class="plp-byob__info"><span class="plp-byob__name">' + esc(p.title) + '</span>' + select +
        '<span class="plp-byob__price">' + (after < v.price ? '<s>' + self.money(v.price) + '</s> ' : '') + '<b>' + self.money(after) + '</b></span></span>' +
        '<button type="button" class="plp-byob__remove" data-byob-remove="' + i + '" aria-label="Remove ' + esc(p.title) + '">&times;</button>' +
        '</li>';
    });
    html += '</ul>';
    var next = nextTier(c.tiers, q.total);
    if (next && this.items.length < c.maxKits) {
      html += '<p class="plp-byob__hint">' + esc(fill(s.panelHint, { remaining: next.qty - q.total, remaining_unit: unit(next.qty - q.total, s), next_pct: next.pct })) + '</p>';
    }
    // The kits already in the cart that count toward the tier, so the
    // customer can see where "+ 3 in cart" comes from.
    var lines = this.cartLines || [];
    if (this.cartCount && lines.length) {
      html +=
        '<div class="plp-byob__incart"><p class="plp-byob__sub plp-byob__sub--cart">' +
        esc(fill(s.panelCart || 'Already in your cart ([count]), counted toward your discount', { count: this.cartCount, count_unit: unit(this.cartCount, s) })) +
        '</p><ul class="plp-byob__list plp-byob__list--cart">';
      lines.forEach(function (line) {
        html +=
          '<li class="plp-byob__row plp-byob__row--cart">' +
          '<span class="plp-byob__thumb">' + (line.image ? '<img src="' + esc(line.image) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</span>' +
          '<span class="plp-byob__info"><span class="plp-byob__name">' + esc(line.title) + '</span>' +
          (line.variant ? '<span class="plp-byob__price">' + esc(line.variant) + '</span>' : '') + '</span>' +
          '<span class="plp-byob__qty">&times; ' + line.quantity + '</span></li>';
      });
      html += '</ul></div>';
    }
    this.q('[data-byob-kits]').innerHTML = html;

    var aHtml = this.addonsHtml(q);
    var aBox = this.q('[data-byob-addons]');
    aBox.innerHTML = aHtml;
    aBox.hidden = !aHtml;
  };

  /** The add-ons list (heading, pill, rows): the tray panel and the sidebar. */
  Tray.prototype.addonsHtml = function (q) {
    var c = this.config;
    var s = c.strings;
    var self = this;
    var addons = this.addonsById();
    var ids = Object.keys(addons);
    var aHtml = '';
    if (ids.length) {
      aHtml +=
        '<div class="plp-byob__addons-head"><p class="plp-byob__panel-title plp-byob__panel-title--sm">' + esc(s.addonsHeading) + '</p>' +
        '<span class="plp-byob__addon-pill' + (q.addonOn ? ' is-on' : '') + '">' +
        esc(fill(q.addonOn ? s.addonOn : s.addonOff, { pct: c.addons.pct, min: c.addons.minKits })) + '</span></div><ul class="plp-byob__list">';
      // Keep the collection order.
      c.addons.items.forEach(function (a) {
        if (!addons[String(a.id)]) return;
        var e = self.extras[String(a.id)];
        var on = !!(e && e.on);
        var v = (e && a.variantsById[e.vid]) || a.variantsById[String(a.variantId)] || a.variants[0];
        var after = q.addonOn ? unitAfter(v.price, c.addons.pct) : v.price;
        var select = self.selectHtml(a, v, 'data-byob-addon-variant="' + a.id + '"');
        aHtml +=
          '<li class="plp-byob__row">' +
          '<span class="plp-byob__thumb">' + (a.image ? '<img src="' + esc(a.image) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</span>' +
          '<span class="plp-byob__info"><span class="plp-byob__name">' + esc(a.title) + '</span>' + select +
          '<span class="plp-byob__price">' + (after < v.price ? '<s>' + self.money(v.price) + '</s> ' : '') + '<b>' + self.money(after) + '</b></span></span>' +
          '<button type="button" class="plp-byob__addon-btn' + (on ? ' is-on' : '') + '" data-byob-addon="' + a.id + '" aria-pressed="' + on + '">' +
          esc(on ? s.addonAdded : s.addonAdd) + '</button>' +
          '</li>';
      });
      aHtml += '</ul>';
    }
    return aHtml;
  };

  /**
   * The sidebar builder, always open on desktop: rows, kits, empty slots to
   * fill, add-ons, total and Add to cart. Same bundle, prices and add as the
   * tray (quote(), submit()).
   */
  Tray.prototype.renderRail = function (q, picked) {
    var c = this.config;
    var s = c.strings;
    var self = this;
    var count = this.items.length;
    // Kits already in the cart are part of "Your kits" too (like the PDP box):
    // they fill the first slots and count toward the size rows.
    var inCart = this.cartCount || 0;
    var have = inCart + count;
    if (this.target && have > this.target) this.target = null;

    // The row shown as chosen: the target, else the tier the kits reach.
    var chosen = this.target;
    if (!chosen) {
      c.tiers.forEach(function (t) {
        if (have >= t.qty) chosen = t.qty;
      });
    }
    var rows = '';
    c.tiers.forEach(function (t) {
      var top = t.qty === c.topQty;
      var on = chosen === t.qty || (top && chosen && chosen > t.qty);
      var flag = c.flags && c.flags[String(t.qty)];
      rows +=
        '<button type="button" class="byob-rail__row' + (on ? ' is-on' : '') + (q.total >= t.qty ? ' is-reached' : '') + (flag ? ' has-flag' : '') +
        '" data-byob-size="' + t.qty + '" aria-pressed="' + on + '">' +
        (flag ? '<span class="byob-rail__flag">' + esc(flag) + '</span>' : '') +
        '<span class="byob-rail__radio" aria-hidden="true"></span>' +
        '<span class="byob-rail__row-text"><b>' + (top ? t.qty + '+ ' : t.qty + ' ') + esc(unit(t.qty, s)) + '</b>' +
        '<small>' + esc(fill(s.railRowSub, { pct: t.pct })) + '</small></span>' +
        '<span class="byob-rail__pill">' + esc(fill(s.railRowPill, { pct: t.pct })) + '</span></button>';
    });

    // Slots: the kits, then empty ones up to the target (the first tier, e.g.
    // 2 kits, until the customer picks a size).
    var target = Math.max(have, this.target || c.tiers[0].qty);
    var targetLabel = this.target && this.target >= c.topQty ? this.target + '+' : String(Math.max(target, have));
    var kits = '';
    (inCart ? this.cartLines || [] : []).forEach(function (line) {
      kits +=
        '<li class="byob-rail__kit is-cart">' +
        '<span class="byob-rail__thumb">' + (line.image ? '<img src="' + esc(line.image) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</span>' +
        '<span class="byob-rail__info"><span class="byob-rail__name">' + esc(line.title) + '</span>' +
        (line.variant ? '<span class="byob-rail__variant">' + esc(line.variant) + '</span>' : '') +
        '<span class="byob-rail__incart">' + esc(s.railInCart || 'In your cart') + '</span></span>' +
        '<span class="byob-rail__qty">&times; ' + line.quantity + '</span>' +
        '</li>';
    });
    this.items.forEach(function (it, i) {
      var p = self.products[it.pid];
      var v = p.variantsById[it.vid] || p.variants[0];
      var img = v.image || p.image;
      var after = unitAfter(v.price, q.pct);
      var select = self.selectHtml(p, v, 'data-byob-variant="' + i + '"');
      kits +=
        '<li class="byob-rail__kit">' +
        '<span class="byob-rail__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</span>' +
        '<span class="byob-rail__info"><span class="byob-rail__name">' + esc(p.title) + '</span>' + select +
        '<span class="byob-rail__price">' + (after < v.price ? '<s>' + self.money(v.price) + '</s> ' : '') + '<b>' + self.money(after) + '</b></span></span>' +
        '<button type="button" class="byob-rail__remove" data-byob-remove="' + i + '" aria-label="' + esc(s.railRemove) + ' ' + esc(p.title) + '">' + esc(s.railRemove) + '</button>' +
        '</li>';
    });
    for (var n = have; n < target; n += 1) {
      kits +=
        '<li class="byob-rail__kit is-empty' + (n === have ? ' is-next' : '') + '"><span class="byob-rail__thumb">' + (n + 1) + '</span>' +
        '<span class="byob-rail__info"><span class="byob-rail__name">' + esc(n === have ? s.railPick : fill(s.railSlot, { n: n + 1 })) + '</span></span></li>';
    }

    var msg = progressMessage(c, q.total, s.trayMsgs);
    var addons = count ? this.addonsHtml(q) : '';
    var cta = this.busy
      ? s.addingLabel
      : count
        ? fill(s.railCta, { total: this.money(q.pay), count: count, count_unit: unit(count, s) })
        : s.railCtaEmpty;

    var scrollBox = this.rail.parentNode;
    var scrollTop = scrollBox ? scrollBox.scrollTop : 0;
    this.rail.innerHTML =
      '<div class="byob-rail__box">' +
      '<p class="byob-rail__title">' + esc(s.railTitle) + '</p>' +
      (s.railSub ? '<p class="byob-rail__sub">' + esc(s.railSub) + '</p>' : '') +
      '<div class="byob-rail__rows">' + rows + '</div>' +
      '<p class="byob-rail__kits-head">' + esc(fill(s.railKits, { count: have, target: targetLabel })) + '</p>' +
      '<ul class="byob-rail__kits">' + kits + '</ul>' +
      (this.cartCount
        ? '<p class="byob-rail__cartnote">' + esc(fill(s.cartNote, { count: this.cartCount, count_unit: unit(this.cartCount, s), total: q.total })) + '</p>'
        : '') +
      (count || this.cartCount ? '<p class="byob-rail__msg">' + esc(msg.text).replace(/\*([^*]+)\*/g, '<em>$1</em>') + '</p>' : '') +
      (addons ? '<div class="byob-rail__addons">' + addons + '</div>' : '') +
      // Total + Add to cart stay pinned at the bottom of the rail while the
      // kits / extras above them scroll.
      '<div class="byob-rail__foot">' +
      (count ? '<div class="byob-rail__total"><s>' + (q.save > 0 ? this.money(q.was) : '') + '</s><b>' + this.money(q.pay) + '</b></div>' : '') +
      '<button type="button" class="byob-rail__cta" data-byob-cta' + (count && !this.busy ? '' : ' disabled') + '>' + esc(cta) + '</button>' +
      (q.save > 0 ? '<p class="byob-rail__save">' + esc(fill(s.saveLabel, { amount: this.money(q.save) })) + '</p>' : '') +
      (this.error ? '<p class="byob-rail__error" role="alert">' + esc(this.error) + '</p>' : '') +
      '</div>' +
      '</div>';
    if (scrollBox) scrollBox.scrollTop = scrollTop;
  };

  Tray.prototype.broadcast = function (q) {
    var detail = { group: this.config.group, cart: this.cartCount, bundle: this.items.length, total: q.total, pct: q.pct };
    var key = JSON.stringify(detail);
    if (key === this.lastBroadcast) return;
    this.lastBroadcast = key;
    document.dispatchEvent(new CustomEvent('plp-byob:update', { detail: detail }));
  };

  Tray.prototype.submit = function (trigger) {
    if (this.busy || !this.items.length) return;
    var self = this;
    var group = this.config.group;
    var byVariant = {};
    var order = [];
    this.items.forEach(function (it) {
      if (!byVariant[it.vid]) {
        byVariant[it.vid] = 0;
        order.push(it.vid);
      }
      byVariant[it.vid] += 1;
    });
    var items = order.map(function (vid) {
      return { id: parseInt(vid, 10), quantity: byVariant[vid], properties: { _mix_match: group } };
    });
    this.pickedAddons().forEach(function (x) {
      items.push({ id: parseInt(x.variant.id, 10), quantity: 1, properties: { _mix_match_addon: group } });
    });

    this.busy = true;
    this.error = '';
    this.render();

    var url = (root.theme && root.theme.routes && root.theme.routes.cartAdd) || '/cart/add.js';
    if (!/\.js$/.test(url)) url += '.js';
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || (result.data && result.data.status)) {
          // 422 (stock etc.): keep the bundle so the customer can fix it.
          self.error = (result.data && result.data.description) || self.config.strings.addError;
          return;
        }
        self.cartCount += self.items.length;
        self.items = [];
        self.extras = {};
        self.open = false;
        self.target = null;
        self.save();
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', { detail: { product: result.data, addToCartBtn: trigger } })
        );
        openCartDrawer();
      })
      .catch(function () {
        self.error = self.config.strings.addError;
      })
      .then(function () {
        self.busy = false;
        self.render();
      });
  };

  // ---------------------------------------------------------------------------
  // Live banner
  // ---------------------------------------------------------------------------

  var banners = [];

  function Banner(el) {
    this.el = el;
    this.config = readJson(el.querySelector('script[data-bmsm-live-config]'));
    if (!this.config || !this.config.valid || !this.config.tiers || !this.config.tiers.length) {
      this.config = null;
      return;
    }
    this.config.tiers.sort(function (a, b) {
      return a.qty - b.qty;
    });
    this.config.strings = this.config.strings || {};
    this.cart = this.config.cartCount || 0;
    this.bundle = 0;
    var self = this;
    this.onCart = function (cart) {
      self.lastCart = cart;
      var r = cartMembers(cart, self.config);
      self.cart = r.count;
      self.render();
      var pending = r.unknown.length && resolveUnknown(self, el.getAttribute('data-section-id'), 'data-bmsm-live-config', r.unknown);
      if (pending) {
        pending.then(function (ok) {
          if (ok !== null) self.onCart(self.lastCart);
        });
      }
    };
    listeners.push(this.onCart);
    this.onUpdate = function (evt) {
      var d = evt.detail || {};
      if (d.group !== self.config.group) return;
      self.cart = d.cart;
      self.bundle = d.bundle;
      self.render();
    };
    document.addEventListener('plp-byob:update', this.onUpdate);
    this.render();
  }

  Banner.prototype.render = function () {
    var c = this.config;
    var total = this.cart + this.bundle;
    var el = this.el;
    Array.prototype.forEach.call(el.querySelectorAll('[data-bmsm-qty]'), function (offer) {
      var q = parseInt(offer.getAttribute('data-bmsm-qty'), 10) || 0;
      var reached = q > 0 && total >= q;
      offer.classList.toggle('is-reached', reached);
      var sr = offer.querySelector('[data-bmsm-sr]');
      if (sr) sr.textContent = reached ? c.strings.reachedLabel || ' (unlocked)' : '';
    });
    var live = el.querySelector('[data-bmsm-live]');
    var support = el.querySelector('[data-bmsm-support-text]');
    var hasText = total > 0;
    if (live) {
      live.hidden = !hasText;
      var msg = progressMessage(c, total, c.strings.msgs);
      var text = live.querySelector('[data-bmsm-live-text]');
      if (text) text.innerHTML = esc(msg.text).replace(/\*([^*]+)\*/g, '<em>$1</em>');
      var bar = live.querySelector('[data-bmsm-live-steps]');
      if (bar) {
        var top = c.topQty || c.tiers[c.tiers.length - 1].qty;
        var html = '';
        for (var i = 1; i <= top; i += 1) html += '<i class="' + (total >= i ? 'is-on' : '') + '"></i>';
        bar.innerHTML = html;
      }
    }
    if (support && c.strings.hideSupport) support.hidden = hasText;
    el.setAttribute('data-bmsm-count', String(total));
  };

  Banner.prototype.destroy = function () {
    var i = listeners.indexOf(this.onCart);
    if (i > -1) listeners.splice(i, 1);
    document.removeEventListener('plp-byob:update', this.onUpdate);
  };

  // ---------------------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------------------

  function initAll(scope) {
    var ctx = scope || document;
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-plp-byob-section]'), function (section) {
      if (section.plpByob) return;
      var tray = new Tray(section);
      if (tray.config) {
        section.plpByob = tray;
        trays.push(tray);
      }
    });
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-bmsm-live-root]'), function (el) {
      if (el.plpByobBanner) return;
      var banner = new Banner(el);
      if (banner.config) {
        el.plpByobBanner = banner;
        banners.push(banner);
      }
    });
    // A tray announces its state; a banner on its own asks the cart.
    trays.forEach(function (t) {
      t.lastBroadcast = null;
      t.render();
    });
  }

  function teardown(scope) {
    trays = trays.filter(function (t) {
      if (scope.contains(t.section)) {
        t.destroy();
        t.section.plpByob = null;
        return false;
      }
      return true;
    });
    banners = banners.filter(function (b) {
      if (scope.contains(b.el)) {
        b.destroy();
        b.el.plpByobBanner = null;
        return false;
      }
      return true;
    });
  }

  document.addEventListener('cart:updated', function (evt) {
    var cart = evt.detail && evt.detail.cart;
    if (cart && cart.items) applyCart(cart);
    else refreshCart();
  });
  document.addEventListener('ajaxProduct:added', function () {
    // Quick Add on a non-kit, the PDP-style modal, or our own add.
    setTimeout(refreshCart, 300);
  });

  /*
   * Cart changes that fire no theme event: UpCart (the cart drawer) removes
   * and changes lines with /cart/change.js and /cart/update.js and only
   * re-renders itself, so the tray / sidebar kept the old "Includes 6 kits
   * already in your cart" after the kits were removed. Any /cart/add|change|
   * update|clear request (fetch or XHR, from anyone) re-reads /cart.js.
   * Also on returning to the tab (the cart may have changed in another one).
   */
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var cartTimer = null;
  function isCartChange(url) {
    try {
      return CART_CHANGE.test(new URL(String(url), root.location.href).pathname);
    } catch (e) {
      return false;
    }
  }
  function refreshCartSoon() {
    if (!trays.length && !banners.length) return;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(refreshCart, 250);
  }
  if (typeof root.fetch === 'function' && !root.fetch.plpByobWatch) {
    var pageFetch = root.fetch;
    var watchedFetch = function (input) {
      var url = input && input.url ? input.url : input;
      var result = pageFetch.apply(this, arguments);
      if (isCartChange(url)) result.then(refreshCartSoon, refreshCartSoon);
      return result;
    };
    watchedFetch.plpByobWatch = true;
    root.fetch = watchedFetch;
  }
  if (root.XMLHttpRequest && !root.XMLHttpRequest.prototype.plpByobWatch) {
    var xhrOpen = root.XMLHttpRequest.prototype.open;
    root.XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartChange(url)) this.addEventListener('loadend', refreshCartSoon);
      return xhrOpen.apply(this, arguments);
    };
    root.XMLHttpRequest.prototype.plpByobWatch = true;
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refreshCartSoon();
  });
  /*
   * The browser's own record of every request, whoever made it. UpCart can
   * keep a reference to fetch taken before this file wrapped it (this file
   * loads deferred, after UpCart and the announcement bar), so its removals
   * never went through the wrapper above: the sidebar kept "Includes 2 kits
   * already in your cart" while the bar (which wraps fetch earlier) was right.
   * Watching the finished requests catches them all.
   */
  if (root.PerformanceObserver) {
    try {
      new root.PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if ((entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest') && isCartChange(entry.name)) refreshCartSoon();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {
      /* old browsers: the wrappers above */
    }
  }
  root.addEventListener('pageshow', function (evt) {
    if (!evt.persisted) return;
    // Back from a product page: the bundle may have changed there.
    trays.forEach(function (t) {
      t.reload();
    });
    refreshCart();
  });
  // Same tab: the announcement bar added the saved bundle to the cart. Our
  // own saves are recognised (lastSaved) and skipped.
  document.addEventListener('mm3:selection', function () {
    trays.forEach(function (t) {
      t.reload();
    });
  });
  // The bundle changed in another tab (a PDP opened from here, for example).
  root.addEventListener('storage', function (evt) {
    if (evt.key && evt.key.indexOf(SHARED_PREFIX) !== 0) return;
    trays.forEach(function (t) {
      t.reload();
    });
  });
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
  document.addEventListener('shopify:section:unload', function (evt) {
    teardown(evt.target);
  });

  function start() {
    initAll(document);
    // The page may come from a cache with an older cart.
    if (trays.length || banners.length) refreshCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  root.PlpByob = {
    loaded: true,
    tierFor: tierFor,
    nextTier: nextTier,
    pctFor: pctFor,
    unitAfter: unitAfter,
    quote: quote,
    countCart: countCart,
    cartMembers: cartMembers,
    progressMessage: progressMessage,
    fill: fill,
    filterVariants: filterVariants,
    handleFromUrl: handleFromUrl,
    refresh: refreshCart,
    trays: function () {
      return trays;
    },
  };
})(window);
